import { User } from '@/types/auth';

export type NavItem = {
  name: string;
  path: string;
  screen?: string;
  screenCodes?: string[];
  adminOnly?: boolean;
};

export const EMPLOYEES_FULL_SCREEN = 'employees_management';
export const EMPLOYEES_BASIC_SCREEN = 'employees_basic';

export const APP_NAV: NavItem[] = [
  { name: 'Roles', path: '/roles', screen: 'roles_management', adminOnly: true },
  {
    name: 'Employee',
    path: '/employees',
    screenCodes: [EMPLOYEES_FULL_SCREEN, EMPLOYEES_BASIC_SCREEN],
  },
  { name: 'FaceID Setup', path: '/face-detection', screen: 'faceid_setup' },
  { name: 'Employee Attendance', path: '/employee-attendance', screen: 'attendance_management' },
  { name: 'Leaves', path: '/leaves', screen: 'leaves_management' },
  { name: 'Payroll', path: '/payroll', screen: 'payroll_management' },
  { name: 'Schedule', path: '/schedule', screen: 'schedules_management' },
];

const ALWAYS_ALLOWED_PREFIXES = ['/profile', '/change-password'];

export function hasScreen(user: User | null | undefined, code: string): boolean {
  return Boolean(user?.screens?.includes(code) || user?.screenAccess?.includes(code));
}

export function canAccessEmployees(user: User | null | undefined): boolean {
  if (user?.isAdmin) {
    return true;
  }
  return hasScreen(user, EMPLOYEES_FULL_SCREEN) || hasScreen(user, EMPLOYEES_BASIC_SCREEN);
}

export function canViewEmployeeSensitiveFields(user: User | null | undefined): boolean {
  if (user?.isAdmin) {
    return true;
  }
  return hasScreen(user, EMPLOYEES_FULL_SCREEN);
}

function hasNavScreenAccess(user: User | null | undefined, item: NavItem): boolean {
  if (item.screenCodes?.length) {
    return item.screenCodes.some((code) => hasScreen(user, code));
  }
  return hasScreen(user, item.screen || '');
}

export function canAccessPath(user: User | null | undefined, path: string): boolean {
  if (ALWAYS_ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return true;
  }

  const item = APP_NAV.find((nav) => path === nav.path || path.startsWith(`${nav.path}/`));
  if (!item) {
    return false;
  }

  if (item.adminOnly) {
    return Boolean(user?.isAdmin);
  }

  if (user?.isAdmin) {
    return true;
  }

  return hasNavScreenAccess(user, item);
}

export function visibleNavItems(user: User | null | undefined): NavItem[] {
  return APP_NAV.filter((item) => canAccessPath(user, item.path));
}

export function defaultHomePath(_user: User | null | undefined): string {
  return '/profile';
}
